import { render } from "./TwoColumn.vue?vue&type=template&id=5e36ded6&ts=true"
import script from "./TwoColumn.vue?vue&type=script&lang=ts"
export * from "./TwoColumn.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__